export var Roles;
(function (Roles) {
    Roles["AccountManager"] = "account_manager";
    Roles["AccountingManager"] = "accounting_manager";
    Roles["Admin"] = "admin";
    Roles["ClientSupportManager"] = "client_support_manager";
    Roles["DtpManager"] = "dtp_manager";
    Roles["EstimationManager"] = "estimation_manager";
    Roles["LogisticsManager"] = "logistics_manager";
    Roles["MarginEditor"] = "margin_editor";
    Roles["MarketingManager"] = "marketing_manager";
    Roles["ProductionManager"] = "production_manager";
    Roles["SalesManager"] = "sales_manager";
    Roles["MarginManager"] = "margin_manager";
    Roles["Sdr"] = "sdr";
})(Roles || (Roles = {}));
//# sourceMappingURL=roles.js.map